import { render } from "./RecipientItem.vue?vue&type=template&id=2c8729ce&scoped=true&ts=true"
import script from "./RecipientItem.vue?vue&type=script&lang=ts"
export * from "./RecipientItem.vue?vue&type=script&lang=ts"

import "./RecipientItem.vue?vue&type=style&index=0&id=2c8729ce&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8729ce"]])

export default __exports__